import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Radio } from "antd";
import saveLog from "../../services/saveLog";
import $ from "jquery";
import axios from "../../services/axios";
import url from "../../services/url";
import Axios from "axios";
import LoadingArea from "../../components/LoadingArea";
import { Checkbox } from "antd";
import messages from "../../services/message";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

const TinRights = () => {
  // States
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [checkedValues, setCheckedValues] = useState({});
  const [canSubmitTinAccess, setCanSubmitTinAccess] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const submitAllowed = await checkPermission(
        userRole,
        "tin_access_manangement_module",
        "submit"
      );
      setCanSubmitTinAccess(submitAllowed);
    } catch (err) {
      console.error("Error checking Tin Access permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  // Effects
  useEffect(() => {
    Axios.get(url("manageTin/tinManagementRights/userList"), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((result) => {
        console.log("Resulty", result.data.tinManagementRights);
        setUsers(result.data.tinManagementRights);
        setTimeout(() => {
          $("#table-datatable").DataTable();
        }, 100);
        setLoading(false);
      })
      .catch(console.error);
  }, [toggle]);

  function onClickSubmit(event) {
    const id = event.target.getAttribute("user");
    const rId = event.target.getAttribute("rId");
    const filterData = users.filter((ele) => {
      return ele._id === rId
    })

    //   Update the server with the new values
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: "manageTin/tinManagementRights/" + rId,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
      data: {
        upload: checkedValues[id].upload === true || checkedValues[id].upload === false ? checkedValues[id].upload : filterData[0]?.upload,
        release: checkedValues[id].release === true || checkedValues[id].release === false ? checkedValues[id].release : filterData[0]?.release,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        messages("Access Rights Updated!", "success", 3)
      })
      .catch((error) => {
        console.log(error);
        messages("something went wrong!", "error", 3)
      })
      .finally(() => {
        setToggle(!toggle);
      });
  }

  const onChange = (e, userId) => {
    const { value, checked } = e.target;

    setCheckedValues((prevState) => ({
      ...prevState,
      [userId]: {
        ...prevState[userId],
        [value]: checked,
      },
    }));
  };

  const handleBlur = () => {
    console.log("handleBlur");
  };

  return (
    <Dashboard title="Tin Access Management">
      <LoadingArea isLoading={loading}>
        <div className="mb-4">
          <table id="table-datatable" className="table table-striped table-trf">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Access Rights</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, key) => (
                <tr key={key}>
                  <td>{user?.userId?.name}</td>
                  <td>{user?.userId?.email}</td>
                  <td>
                    <Checkbox
                      defaultChecked={user.upload}
                      onChange={(e) => onChange(e, user.userId._id)}
                      value="upload"
                    >
                      Upload
                    </Checkbox>
                    <Checkbox
                      defaultChecked={user.release ? true : ""}
                      onChange={(e) => onChange(e, user?.userId?._id)}
                      value="release"
                    >
                      Release
                    </Checkbox>
                  </td>
                  <td>
                    {canSubmitTinAccess && (
                      <button
                        user={user?.userId?._id}
                        rId={user?._id}
                        onClick={onClickSubmit}
                        className="btn btn-sm btn-danger mx-1"
                      >
                        Submit
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </LoadingArea>
    </Dashboard>
  );
};

export default TinRights;
